const NAMESPACE = "attachment";

const KEYS = {
    electronicSignatureChosenLabel: "electronicSignatureChosenLabel",
    signAndUploadChosenLabel: "signAndUploadChosenLabel",
    changeSignatureTypeButtonLabel: "changeSignatureTypeButtonLabel",
    selectSignatureTypeLabel: "selectSignatureTypeLabel",
    chooseESignatureButtonLabel: "chooseESignatureButtonLabel",
    chooseSignAndUploadButtonLabel: "chooseSignAndUploadButtonLabel",
    outForSigningMessage: "outForSigningMessage",
    viewButtonLabel: "viewButtonLabel",
    previewDocumentButtonLabel: "previewDocumentButtonLabel",
    attachmentStatusNoteText: "attachmentStatusNoteText",
    attachmentStatusLabel: "attachmentStatusLabel",
    uploadedByMessageText: "uploadedByMessageText",
    receivedOnMessageText: "receivedOnMessageText",
    customRemoveFileMessage: "customRemoveFileMessage",
    templateErrorMessage: "templateErrorMessage",
    showSignatoryErrorMessage: "showSignatoryErrorMessage",
    extractorWarningDialogTitle: "extractorWarningDialogTitle"
};

const MESSAGES = {
    [KEYS.electronicSignatureChosenLabel]: {
        value: "(Electronic Signature)",
        comment: "Message to display when electronic signature has been chosen"
    },
    [KEYS.signAndUploadChosenLabel]: {
        value: "(Sign and Upload)",
        comment: "Message to display when sign and upload option has been chosen"
    },
    [KEYS.changeSignatureTypeButtonLabel]: {
        value: "Change Signature Type",
        comment:
            "Label for button which when clicked returns the user to choosing between esignatures and sign-and-upload"
    },
    [KEYS.selectSignatureTypeLabel]: {
        value: "Select Signature Type:",
        comment: "Label for section to select between the two signature types"
    },
    [KEYS.chooseESignatureButtonLabel]: {
        value: "eSign",
        comment: "Label for button to select e-signatures as the preferred signature format"
    },
    [KEYS.chooseSignAndUploadButtonLabel]: {
        value: "Sign and Upload",
        comment: "Label for button to select sign and upload as the preferred signature format"
    },
    [KEYS.outForSigningMessage]: {
        value: "Out for signing",
        comment: "Message to display when a signature has been requested but not completed"
    },
    [KEYS.viewButtonLabel]: {
        value: "View",
        comment: "Label for button to view the attachment"
    },
    [KEYS.previewDocumentButtonLabel]: {
        value: "Preview Document",
        comment: "Label for button which when clicked previews the document"
    },
    [KEYS.attachmentStatusNoteText]: {
        value: "Note",
        comment: "Note message for attachment status"
    },
    [KEYS.attachmentStatusLabel]: {
        value: "Status",
        comment: "Label for attachment status section"
    },
    [KEYS.uploadedByMessageText]: {
        value: "Uploaded by {firstName} {lastName} on {date}",
        comment: "Message communicating when, and by whom, a file was uploaded"
    },
    [KEYS.receivedOnMessageText]: {
        value: "Electronically signed document received {date}",
        comment: "Message to display when a signed document was received"
    },
    [KEYS.customRemoveFileMessage]: {
        value: "Are you sure you want to remove this attachment?",
        comment: "Confirmation message when removing an attachment"
    },
    [KEYS.templateErrorMessage]: {
        value: "Generate/Sign Document eSignature Options is selected, but Document Template has not been specified. Field not enabled.",
        comment: "Message to display when eSignatures have been chosen but no template has been specified"
    },
    [KEYS.showSignatoryErrorMessage]: {
        value: "Generate/Sign Document eSignature Options and Document Template are specified, but no Signatories have been configured. Field not enabled.",
        comment:
            "Message to display when eSignatures have been chosen and a template is provided, but no signatory has been enabled"
    },
    [KEYS.extractorWarningDialogTitle]: {
        value: "Data Extractor Warning",
        comment: "Title of extractor dialog to display warnings"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
